import React, { useEffect, useMemo } from 'react';
import { IOptionType, ProjectDialog } from '@zz2/zz2-ui';
import { IFreshServiceTicketFormValues } from '../../@types/model/freshService/freshServiceTicketModels';
import FreshServiceTicketModelHelper from '../../@types/model/freshService/freshServiceTicketModelHelper';
import { useLocation } from 'react-router';
import EnvHelper from '../../service/helper/envHelper';
import { VERSION } from '../../version';
import { useAppSelector } from '../../@types/redux';
import FreshServiceTicketForm from './FreshServiceTicketEditForm';
import { useGetUsers } from '../../hooks/query/users/userQueries';
import { useHandleCreateFreshTicket } from '../../hooks/query/freshService/freshServiceQueries';

interface IFreshServiceTicketEditDialogProps {
    isOpen : boolean;
    onDismiss : () => void;
    title ?: string;
    description ?: string;
}

const FreshServiceTicketCreationDialog = (props : IFreshServiceTicketEditDialogProps) : React.ReactElement => {
    const location = useLocation();
    const currentUser = useAppSelector(x => x.auth.session?.user);

    const { isLoading: isUpsertingFreshServiceTicket, mutate: upsertFreshServiceTicket, isSuccess: upsertSuccess } = useHandleCreateFreshTicket();
    const { isLoading: isLoadingUsers, data: users } = useGetUsers(true, true);

    useEffect(() => {
        props.onDismiss();        
    }, [upsertSuccess]);

    const onSubmit = async (values : IFreshServiceTicketFormValues) : Promise<void> => {
        const upsert = FreshServiceTicketModelHelper.createUpsert(values);
        
        upsertFreshServiceTicket(upsert);
    };

    const userOptions = useMemo<Array<IOptionType>>(() => {
        return users?.map(x => {
            return {
                label: x.name,
                value: x.id
            };

        }) ?? [];

    }, [users]);

    const getInitialFormValues = () : IFreshServiceTicketFormValues => {
        const systemName = EnvHelper.getEnvName();

        return FreshServiceTicketModelHelper.createFormValues(
            systemName, 
            VERSION.version, 
            location.pathname, 
            currentUser?.name ?? '',
            currentUser?.email ?? '',
            props.description
        );
    };

    return (
        <ProjectDialog
            title={'ZZ2 Fresh Service Support Ticket'}
            isLoadingCircular={isUpsertingFreshServiceTicket || isLoadingUsers}
            isOpen={props.isOpen}
            fullWidth
            maxWidth={'sm'}
            onClose={props.onDismiss}>
            <FreshServiceTicketForm initialValues={getInitialFormValues()} onSubmit={onSubmit} onCancel={props.onDismiss} userOptions={userOptions} />
        </ProjectDialog>
    );
};


export default FreshServiceTicketCreationDialog;